import PropTypes from 'prop-types';
import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const DonutChart = ({ background, value, displayValue, isTopQuartile }) => {
    // Data for the chart
    const data = [
        { name: 'Category A', value: 100 - value },
        { name: 'Category B', value },
    ];

    // Helper functions for stroke properties
    const getStrokeColor = () => {
        if (background === '#ffffff') return '#000000';
        if (isTopQuartile) return '#ffa200';
        return 'none';
    };

    const getStrokeWidth = () => {
        if (background === '#ffffff') return 1;
        if (isTopQuartile) return 2;
        return 0;
    };

    return (
        <div style={{ textAlign: 'center', position: 'relative', width: '200px' }}>
            {value === 100 && isTopQuartile ? (
                // For 100% AND top quartile, use SVG circles with yellow borders on inner and outer edges
                <svg width={100} height={100}>
                    {/* Outer circle with yellow border */}
                    <circle cx="50" cy="50" r="32" fill={background} stroke="#ffa200" strokeWidth="2" />
                    {/* Inner circle (hole) with white fill and yellow border */}
                    <circle cx="50" cy="50" r="20" fill="white" stroke="#ffa200" strokeWidth="2" />
                </svg>
            ) : (
                // For other cases, use PieChart with angles and white center overlay
                <div style={{ position: 'relative' }}>
                    <PieChart width={100} height={100}>
                        <defs>
                            <linearGradient id="gradientColor" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#0088FE" />
                                <stop offset="100%" stopColor="#00C49F" />
                            </linearGradient>
                        </defs>
                        <Pie
                            data={data}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            innerRadius={20} // Inner radius to create the "donut" effect
                            outerRadius={32}
                            fill="#8884d8"
                            paddingAngle={0} // No gap between partitions
                            startAngle={90} // Start angle for better alignment
                            endAngle={450} // End angle for a full circle
                        >
                            <Cell key="cell-1" fill="#efeeef" />
                            <Cell
                                key="cell-0"
                                fill={background}
                                stroke={getStrokeColor()}
                                strokeWidth={getStrokeWidth()}
                            />
                        </Pie>
                    </PieChart>
                    {/* White center circle overlay */}
                    <svg
                        width={100}
                        height={100}
                        style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}
                    >
                        <circle cx="50" cy="50" r="20" fill="white" />
                    </svg>
                </div>
            )}
            {/* Percentage indicator in the middle */}
            <div
                style={{
                    position: 'absolute',
                    top: value === 100 ? '48%' : '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '1.6vh',
                    color: '#333',
                }}
            >
                {displayValue}
            </div>
        </div>
    );
};
DonutChart.propTypes = {
    background: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    displayValue: PropTypes.string.isRequired,
    isTopQuartile: PropTypes.bool,
};

DonutChart.defaultProps = {
    isTopQuartile: false,
};

export default DonutChart;
